export const featureKeys = {
  FRIENDLY_ERRORS: "friendly_errors",
  TRANSFER_OWNERSHIP: "classroom_transfer_ownership",
  AI_ERRORS: "ai_friendly_errors",
};

export const isOfflineEnabled = (): boolean =>
  process.env.REACT_APP_OFFLINE_ENABLED === "true";
